import { useQuery } from '@tanstack/react-query'
import { dashboardClient } from '@/api'
import { ResourceState } from '@/api/dashboard'

interface UseRollingOffersQueryParams {
  companyId: string
  gameId: string
  limit?: number
  offset?: number
  state?: ResourceState
}

export const useRollingOffersQuery = ({
  companyId,
  gameId,
  limit = 100,
  offset = 0,
  state = ResourceState.Active,
}: UseRollingOffersQueryParams) => {
  const params = {
    companyId,
    gameId,
    limit,
    offset,
    state,
  }

  return useQuery({
    queryKey: ['rolling_offers', gameId, params],
    select: response => response.data,
    queryFn: () => dashboardClient.v1.getRollingOffers(params),
  })
}
